import { render } from "./KRTypeActivity.vue?vue&type=template&id=57705726"
import script from "./KRTypeActivity.vue?vue&type=script&lang=js"
export * from "./KRTypeActivity.vue?vue&type=script&lang=js"
script.render = render

export default script